<template>
  <div
    class="min-h-screen w-full bg-gray-100 flex items-center justify-center dark:bg-dark-700"
  >
    <div
      class="grid grid-cols-1 md:grid-cols-2 w-full max-w-6xl bg-white rounded-lg shadow-lg mx-5"
    >
      <!-- Left Column: Image and Description -->
      <div
        class="hidden md:block p-6 rounded-lg md:rounded-l-lg md:rounded-r-none dark:bg-dark-800"
      >
        <img
          src="@/assets/logo-erista.png"
          alt="Logo"
          class="w-full h-full object-cover"
        />
      </div>

      <!-- Right Column: Login Form -->
      <div
        class="p-6 bg-dark-900 dark:bg-dark-900 text-light-50 dark:text-dark-50 rounded-lg md:rounded-r-lg md:rounded-l-none"
      >
        <h2 class="text-2xl font-bold text-center text-white mb-6">Login</h2>
        <span
          id="errorMessage"
          v-show="errorMessage"
          class="text-red-700 w-full bg-red-300 font-medium px-3 py-2 rounded-md flex items-center"
        >
          <ExclamationTriangleIcon class="w-5 h-5 me-2" />
          {{ errorMessage }}
        </span>
        <form @submit.prevent="handleLogin">
          <!-- Email Field -->
          <InputText
            id="user-email"
            v-model="email"
            type="text"
            label="Username"
            label_class="text-white font-medium"
            placeholder="Username anda"
            input_class="w-full mb-5"
          />

          <!-- Password Field -->
          <InputPassword
            id="user-password"
            v-model="password"
            label="Password"
            label_class="text-white block text-start font-medium"
            placeholder="Password anda"
            input_class="w-full mb-5"
          />

          <!-- Submit Button -->
          <div class="flex justify-center">
            <button
              type="submit"
              :disabled="isLoading"
              class="w-full bg-primary text-white py-2 rounded-md hover:bg-hover-primary transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
              @click="login"
            >
              <svg
                v-if="isLoading"
                class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              {{ isLoading ? "Loading..." : "Login" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/form/InputText.vue";
import InputPassword from "@/components/form/InputPassword.vue";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/solid";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "AuthView",
  components: {
    InputPassword,
    InputText,
    ExclamationTriangleIcon,
  },
  computed: {
    ...mapGetters("detail_user", ["detailUser"]),
    ...mapGetters("role_permissions", ["allRolePermissions"]),
    ...mapGetters("outlets", ["allOutlets"]),
  },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      isLoading: false,
    };
  },
  async created() {
    await this.$store.dispatch("detail_user/fetchUser");
    if (localStorage) {
      this.$router.push("/dashboard");
    }
  },
  methods: {
    async login() {
      this.isLoading = true;
      this.errorMessage = "";

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_ROOT_API}/auth`,
          {
            username: this.email,
            password: this.password,
          }
        );

        if (response.data.status == "success") {
          const token = response.data.data.token;
          localStorage.setItem("auth_token", token);

          await this.$store.dispatch("detail_user/fetchUser");
          const detailuser = await this.$store.dispatch(
            "users/fetchUserById",
            this.detailUser.id
          );
          if (detailuser.status == "success") {
            localStorage.setItem("outlet_id", detailuser.data.outlet_id);
            localStorage.setItem("role_id", detailuser.data.role_id);
            this.$router.push("/dashboard");
          }
        } else {
          this.errorMessage = response.data.message;
          this.isLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.errorMessage = "Username atau Password salah";
        this.isLoading = false;
      }
    },
  },
};
</script>
